<template>
  <a href="#" @click="login" class="button button-google button-icon button-icon-left button-round text-white">
    <span class="icon fa fa-google"></span>
    <span>Google</span>
  </a>
</template>

<script>
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { AuthState, namespaceAuth, AuthActionTypes } from "../store/auth";

@Component({
  name: "GoogleLoginButton",
  components: {}
})
export default class extends Vue {
  async mounted() {}
  login = async () => {
    this.$store.dispatch(`${namespaceAuth}/${AuthActionTypes.GetSocialAccessToken}`, { provider: "google" });
  };
}
</script>

<style lang="scss"></style>
